<template>   
  <div>
    <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane">
          <div class="question-box">
            <div class="box-number">              
              <div>
                {{questionNumber}}
                <sup class="question-number-sup">.1</sup>
                <span class="d-none question-title">Pregunta</span>
              </div>
            </div>
          </div>         
          <div class="question-box-content">
              <div class="question-line col">               
                  <div class="row mb-0 p-2 pl-4">
                      <div v-if="!disabled" class="col-4 border-right mt-3">
                          <ValidationProvider
                              v-slot="{ errors }"
                              :rules="dropDownConditionCatalog.required ? 'required' : ''"
                              name="ConditionsInProcessNecessary"
                          >
                          <CustomDropDown
                              id="conditionsCatalog"
                              v-model="value.eligibilityDeterminationConditions.condition"
                              class="w-50 d-inline"     
                              label="Catálogo de condiciones:"         
                              custom-error-msg="Favor seleccionar al menos uno para continuar"
                              :error="errors[0]"               
                              placeholder="Seleccione"
                              fieldkey="id"
                              fieldname="name"
                              :options="conditions"
                              :disabled="disabled"              
                          />
                          </ValidationProvider>
                          <div v-if="!disabled" class="mt-4 d-flex justify-content-end">
                          <ActionButton
                              id="btnAddEligibilityDeterminationConditionClick"
                              i="fas fa-file-plus"
                              variant="success mt-1 pl-5 pr-5"
                              type="button"
                              :disabled="disabled"
                              @click="addEligibilityDeterminationConditionHandler"
                          >
                              Añadir
                          </ActionButton>
                          </div>
                      </div>
                      <div class="col-4" v-if="value.eligibilityDeterminationConditions.selectedItems.length > 0">
                          <CustomChipsGroup
                              title="Condicion(es) Seleccionada(s):"
                              no-background
                              object-text="name"
                              object-title="title"
                              object-sub-title="subTitle"
                              :selected-items="this.value.eligibilityDeterminationConditions.selectedItems"
                              :disabled="disabled"
                              @itemMarkedForDeletion="removeAddEligibilityDeterminationConditionItemSelected" 
                          />
                      </div>         
                  </div>  
              </div>  
          </div>      
        </div> 
      </div> 
    </div> 
  </div> 
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { CustomRadio, ActionButton, CustomDropDown, CustomChipsGroup } from '@/components/common';
import alert from '@/mixin/alert.mixin';
import _ from 'lodash';
export default {
  name: 'PeiEligibilityDeterminationConditions',
  mixins: [alert], 
  components: {
    CustomRadio,
    ActionButton,
    CustomDropDown,
    CustomChipsGroup,
    ValidationProvider
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
         return {                        
            eligibilityDeterminationConditions: {
                condition: null,
                selectedItems: [],
            },           
         }
      }
    },
    questionNumber: {
      type: String,
      required: true,
      default: () => 'P1'
    },
    conditions: {
        type: Array,
        required: true,
        default:()=> {
            return [];
        }
    },
    disabled: {
        type: Boolean,
        required: true,
        default:()=> false                    
    }
  },  
  data() {
    return {
       radioConditionsInProcessNecessary: {
          options: [
            { label: 'Si', value: true },
            { label: 'No', value: false },
          ],
        },
        dropDownConditionCatalog:{            
          required: true          
        }           
    };
  },  
  methods: {
     addEligibilityDeterminationConditionHandler(){
      if (!this.value.eligibilityDeterminationConditions.condition) {
        this.ShowToast('Error', 'Debe seleccionar una opción', 'error');        
        return false;
      }      

      let item = {};
      item.id = this.value.eligibilityDeterminationConditions.condition.id;
      item.association = null;
      item.code = this.value.eligibilityDeterminationConditions.condition.code;
      item.title = this.value.eligibilityDeterminationConditions.condition.name;
        
      this.removeEligibilityDeterminationCondition(item);    
    },    
    removeEligibilityDeterminationCondition(item) {
      this.value.eligibilityDeterminationConditions.selectedItems.push(item);
      this.dropDownConditionCatalog.required = false;       
      this.value.eligibilityDeterminationConditions.condition = null;
      this.conditions = this.conditions.filter(
        (x) => x.id !== item.id
      );     
    },
    removeAddEligibilityDeterminationConditionItemSelected(item) {
      if (item.title) {
        item.name = item.title;
      }      

      const conditionsToOrder = [...this.conditions];
      this.conditions = [];
      conditionsToOrder.push(item);      

      this.conditions = _.orderBy(conditionsToOrder, 'code', 'asc');            

      this.value.eligibilityDeterminationConditions.condition = null;
      this.value.eligibilityDeterminationConditions.selectedItems = this.value.eligibilityDeterminationConditions.selectedItems.filter(
        (x) => x.id !== item.id
      );

      this.dropDownConditionCatalog.required = true; 
      if(this.value.eligibilityDeterminationConditions.selectedItems.length)
      {
        this.dropDownConditionCatalog.required = false; 
      }
    },
    radioConditionsInProcessNecessaryChange(getIsConditionsInProcessNecessary) {
      //get to avoid broke anothers implements

      if (getIsConditionsInProcessNecessary == null) {
        this.value.isConditionsInProcessNecessary = null;        
      } else {
        this.value.isConditionsInProcessNecessary = getIsConditionsInProcessNecessary;        
      }
    },
  }
};
</script>

<style scoped lang="scss">
 .custom-ddl{
   ::v-deep {
    .input-label{
      color: #212529 !important;
    }
  }
}

.custom-radio{
    ::v-deep{
        div.col-12{
            padding-left: 0;
        }
    }
}

.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;  
}

.question-box-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.box-label {
  font: 15px Lato;
  display: block;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.question-number-sup {
  font: 21px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
</style>

